import Jumbotron from './Jumbotron';
const Infosys = () => {
  return (
    <>
      <Jumbotron />
      <div className="page-padd mt-4">
        <div className="accordion" id="accordionExample">
          <div className="card">
            <div className="card-header p-0" id="headingOne">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Course Overview
                </button>
              </h2>
            </div>

            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Course Overview</h5>
                <p>We will have 7 modules and each module has 14 days of duration. In each module, you will see a reading summary, discussion, and assignments. An assignment could be a written paper summary with 1 page supporting materials, a quiz (true/false questions), midterm (5 page publishable paper with 5-page supporting materials), or a final (10-page publishable paper with 10-page supporting materials).</p>
                <p>The discussion/participation/attendance (class works) has 35% of the course and you need to interact with your className on the assigned subject of the discussion during each module (at least 5 scattered entries).</p>
                <p>Please feel free to contact me at <a href="mailto:ebrahimia@oldwestbury.edu">ebrahimia@oldwestbury.edu</a> or <a href="mailto:drebrahimidr@gmail.com">drebrahimidr@gmail.com</a> or call/text my cell 917-279-4432.</p>
                <div className="text-center mt-3">
                  <a href="http://www.drebrahimi.com/Data/Sites/1/information_systems_for_management_sylla.pdf" target="_blank" className="btn btn-primary text-white mr-2">Course Syllabus</a>
                  <a href="http://www.drebrahimi.com/Data/Sites/1/gradingsummary.pdf" target="_blank" className="btn btn-secondary text-white">Grading Summary</a>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingOne1">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseOne1" aria-expanded="false" aria-controls="collapseOne1">
                  Module One
                </button>
              </h2>
            </div>
            <div id="collapseOne1" className="collapse" aria-labelledby="headingOne1" data-parent="#accordionExample">
              <div className="card-body">
                <div id="ctl01_mainContent_ctl00_divContent" className='text-center'>
                  <p>
                    <strong><a href="http://www.drebrahimi.com/Data/Sites/1/whymanagersshouldbecomebetteracquaintedwithprogrammingissues,.pdf">Dr. Ebrahimi's Article: Why should manager know about information technology</a><br />
                    </strong>Read this article and discuss it in the discussion then write one page summary as assignment.&nbsp;</p>
                  <p>
                    &nbsp; The International Journal of Applied Management and Technology (2005), Vol 3, Num 2<b><font face="Times-Bold" size="6"> </font></b></p>
                  <p>
                    <b><font face="Times-Bold" size="6">Why Managers Should Become Better Acquainted</font></b></p>
                  <p>
                    <b><font face="Times-Bold" size="6">With Programming Issues, Web Source Code, and</font></b></p>
                  <p>
                    <b><font face="Times-Bold" size="6">Technology?</font></b></p>
                  <p>
                    <b><font face="TimesNewRomanPS-BoldMT" size="4">Alireza Ebrahimi, State University of New York,</font></b></p>
                  <p>
                    <b><font face="TimesNewRomanPS-BoldMT" size="4">College at Old Westbury, USA</font></b></p>
                  <p>
                    <b><font face="TimesNewRomanPS-BoldMT" size="4">Abstract</font></b></p>
                  <p>
                    <font face="TimesNewRomanPSMT">There has been a controversial debate over how well managers need to acquainted with the</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">area of information technology, especially about what managers need to know of programming</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">and understanding of web source code. Information is an indispensable key to business success</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">and Information Technology (IT) facilitates the ability of business to use information to its</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">advantage. It is the programs (software) that drive technology, the web page presents the</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">business enterprise to everyone. In the heart of every business there also are managers</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">responsible for keeping the records of performance, and using the records to promote efficiency,</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">discipline, and to get the job done. Today’s in-depth involvement of technology in the</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">marketplace has created a strong correlation between IT and managers. Over time, the bond</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">between a manager and IT is becoming stronger, signaling the need for more interaction and</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">understanding of both technical capabilities and business goals on the part of managers.</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">This paper posits that managers need to know more about information technology and</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">actively participate in the IT decision-making team. Furthermore, it suggests how managers can</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">have incrementally to acquire some elementary knowledge of programming issues, what shows</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">on the web, what is behind the web (source code), and what is placed on the server (database). In</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">a dynamic market where changes are made in nanoseconds. It is rewarding and may soon become</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">almost mandatory that a multi-talented manager will have to deal with change, to add or supervise</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">addition of pragmatic programming, and web update the web in order to be competitive. Key to</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">the process is the increasing communication and interaction between managers and programmers.</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">The benefit of understanding the elementary steps of programming and web technology is that it</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">will allow a manager to play a larger role in communicating and delegating responsibility with</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">confidence, and competence thus leading to cost reduction and better short- and long-term risk</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">management.</font></p>
                  <p>
                    <font face="TimesNewRomanPS-BoldMT" size="4"><b>Keywords</b></font></p>
                  <p>
                    <font face="Times-Roman">Technology, Managers, Programming, Web, Source Code, Manager Update, Crisis and Chaos,</font></p>
                  <p>
                    <font face="Times-Roman">Virus, Y2K, E-Business, Software Engineering, Risk Management.</font></p>
                  <p>
                    <font face="TimesNewRomanPS-BoldMT" size="4"><b>Programming Argument</b></font></p>
                  <p>
                    <font face="Times-Roman">In 1982, Robert Benjamin forecasted the state of IT in the year of 1990 stating that all</font></p>
                  <p>
                    <font face="Times-Roman">aspects of software will improve steadily, and the demand for software will be so great as to</font></p>
                  <p>
                    <font face="Times-Roman">appear infinite (Benjamin,1992). Now, nearly fifteen years later, we are experiencing the</font></p>
                  <p>
                    <font face="Times-Roman">fulfillment of these critical IT predictions, and the far more fundamental knowledge and</font></p>
                  <p>
                    <font face="Times-Roman">coordination of managers and the programmers they must direct.</font></p>
                  <p>
                    <font face="Times-Roman">Why is it crucial for a manager to keep up to date with programming issues and web</font></p>
                  <p>
                    <font face="Times-Roman">technology? One may assumes it is not part of a manager’s job description since programming is</font></p>
                  <p>
                    <font face="Times-Roman">associated with complex theories, mathematics, and gibberish code. Furthermore many also</font></p>
                  <p>
                    <font face="Times-Roman">assume there are mathematical formulas and theoretical concepts are involved in creating a</font></p>
                  <p>
                    <font face="Times-Roman">webpage (front end) or in a web server program (back end)? However the technology and its</font></p>
                  <p>
                    <font face="Times-Roman">programming have become less cumbersome than a decade ago, the problems can be easily</font></p>
                  <p>
                    <font face="Times-Roman">worked around by some explanation. We do not suggest that managers become programmers</font></p>
                  <p>
                    <font face="Times-Roman">who know details of syntax and semantic jargon of each programming language construct.</font></p>
                  <p>
                    <font face="Times-Roman">Rather they should become aware of the fundamental changes in programming and be able to</font></p>
                  <p>
                    <font face="Times-Roman">identify simple programming concepts such as input/output, decision-making, repetition, and file</font></p>
                  <p>
                    <font face="Times-Roman">handling. Managers need to be updated, to identify new simple concept of how to use</font></p>
                  <p>
                    <font face="Times-Roman">programming, communicate with programmers employed by their corporations and how to take</font></p>
                  <p>
                    <font face="Times-Roman">advantage of web technology. Similarly the programmers and web page specialists need to have</font></p>
                  <p>
                    <font face="Times-Roman">a through idea of the purpose production and </font><font face="Times-Italic"><i>Modus vivendi </i></font><font face="Times-Roman">of the company. Furthermore, a</font></p>
                  <p>
                    <font face="Times-Roman">manager may be able to visualize a concept as to how it is used or should be used.</font></p>
                  <p>
                    <font face="Times-Roman">According to the U.S. Bureau of Labor Statistics, there are roughly 100 million</font></p>
                  <p>
                    <font face="Times-Roman">information users in the U.S. More interestingly, Sutcliffeis estimates that by 2005 in the U.S.</font></p>
                  <p>
                    <font face="Times-Roman">alone, there would be 55 million end-user developers in addition to 2.75 million professional</font></p>
                  <p>
                    <font face="Times-Roman">software developers. From the above estimate, one can conclude that one out of five people in</font></p>
                  <p>
                    <font face="Times-Roman">the U.S. population (295 million) has to deal with programming issues and write some sort of</font></p>
                  <p>
                    <font face="Times-Roman">program. Sutcliffe and Mehandjiev describe that End-user development is about taking control -</font></p>
                  <p>
                    <font face="Times-Roman">not only of personalizing computer applications (end-user computing) and writing programs, but</font></p>
                  <p>
                    <font face="Times-Roman">of designing new computer-based applications without ever seeing the underlying program code</font></p>
                  <p>
                    <font face="Times-Roman">(Sutcliffe, 2004).</font></p>
                  <p>
                    <font face="TimesNewRomanPS-BoldItalicMT" size="4"><i><b>Programming Simplicity</b></i></font></p>
                  <p>
                    <font face="Times-Roman">A program is a set of instructions telling the computer what to do. Programming is</font></p>
                  <p>
                    <font face="Times-Roman">straightforward with three foundations: Sequence, Decision-making, and Repetition, all known</font></p>
                  <p>
                    <font face="Times-Roman">as control flow. Each instruction in a control flow interacts with the memory bank for storing,</font></p>
                  <p>
                    <font face="Times-Roman">recalling, and modifying one value at a time. The simplicity of a program’s control flow can be</font></p>
                  <p>
                    <font face="Times-Roman">explained by comparing it to the flow of water cascading down step by step like a waterfall. A</font></p>
                  <p>
                    <font face="Times-Roman">waterfall that starts at the top and flows directly to the bottom is sequential control flow, with</font></p>
                  <p>
                    <font face="Times-Roman">only one path. If the water flow reaches a point where it can go either one way or the other, this</font></p>
                  <p>
                    <font face="Times-Roman">point represents a decision. If the water flows back to a point of origin and cycles, this is</font></p>
                  <p>
                    <font face="Times-Roman">repetition. Before each cycle begins, there is a decision on whether to repeat the cycle or to exit.</font></p>
                  <p>
                    <font face="Times-Roman">At each step of the flow there is interaction with the memory and, possibly, with the user.</font></p>
                  <p>
                    <font face="Times-Roman">With this limited programming knowledge which includes: putting instructions into</font></p>
                  <p>
                    <font face="Times-Roman">order; input/output; making decisions; repetition; and file handling, one can accomplish what is</font></p>
                  <p>
                    <font face="Times-Roman">necessary you need to do and better communicate (Ebrahimi, 2003). Given a limited knowledge</font></p>
                  <p>
                    <font face="Times-Roman">of programming, how have senior managers and executives been able to show competence in</font></p>
                  <p>
                    <font face="Times-Roman">understanding the process of programming? What would be the role of the managers in this?</font></p>
                  <p>
                    <font face="Times-Roman">Most senior managers and executives don’t understand software because they haven’t had the</font></p>
                  <p>
                    <font face="Times-Roman">experience of direct involvement in a software development project, however when they went</font></p>
                  <p>
                    <font face="Times-Roman">through the replication during an experiment they were able to gain a sense and feeling of how a</font></p>
                  <p>
                    <font face="Times-Roman">software product is created and how it interacts. Armour has found it "fun and interesting" to see</font></p>
                  <p>
                    <font face="Times-Roman">executives code. (Armour, 2004).</font></p>
                  <p>
                    <font face="Times-BoldItalic" size="4"><i><b>Programming and Language Problems</b></i></font></p>
                  <p>
                    <font face="Times-Roman">Although programming languages have changed only slightly over the last fifty years, the</font></p>
                  <p>
                    <font face="Times-Roman">textual representation of control flow makes it hard to follow the course of a program and</font></p>
                  <p>
                    <font face="Times-Roman">understand what is happening. A program in execution does not necessarily follow the order of</font></p>
                  <p>
                    <font face="Times-Roman">the program written by a programmer. Similarly, arcane notations used for language constructs</font></p>
                  <p>
                    <font face="Times-Roman">are contributing to programming errors themselves. Some new language constructs are more</font></p>
                  <p>
                    <font face="Times-Roman">confusing, unfriendly compared to their predecessors and these new constructs are justified</font></p>
                  <p>
                    <font face="Times-Roman">based on personal preference. The bottom-line is that not much has changed with regard to</font></p>
                  <p>
                    <font face="Times-Roman">programming and its languages. Is this good or bad news? For those who believe in technology</font></p>
                  <p>
                    <font face="Times-Roman">and change, it is bad news. The criticism that programming and programming languages have</font></p>
                  <p>
                    <font face="Times-Roman">fallen behind the technology they have created leads one to wonder whether the programming</font></p>
                  <p>
                    <font face="Times-Roman">can meet the needs of the unit it is supposed to streamline and improve. The good news is that</font></p>
                  <p>
                    <font face="Times-Roman">due to the relative stability of programming and languages, it is possible to encourage managers</font></p>
                  <p>
                    <font face="Times-Roman">to take advantage of the situation and deal with it. The problems of arcane notations and</font></p>
                  <p>
                    <font face="Times-Roman">programming errors still persist and there is hope that a big change will eventually come</font></p>
                  <p>
                    <font face="Times-Roman">(Ebrahimi, 1992). Yet, to be "ironed out" the wrinkles and quirks need to be worked out by the</font></p>
                  <p>
                    <font face="Times-Roman">team of managers of businesses and programmers and web workers.</font></p>
                  <p>
                    <b><font face="Times-Bold" size="4">Technology Crisis and Some historical Lessons</font></b></p>
                  <p>
                    <b><font face="Times-BoldItalic" size="4"><i>Software Engineering</i></font></b></p>
                  <p>
                    <font face="Times-Roman">After the introduction of Integrated Circuits (IC’s), programmers became free from</font></p>
                  <p>
                    <font face="Times-Roman">dealing with the small size memory associated with transistors. Programmers soon could write</font></p>
                  <p>
                    <font face="Times-Roman">many large programs without much restriction. With this overabundance of programming, the</font></p>
                  <p>
                    <font face="Times-Roman">situation went so out of hand it caused chaos. As a result, there was a call for a NATO</font></p>
                  <p>
                    <font face="Times-Roman">conference in Europe in 1968 at which the term Software Engineering was coined. Several</font></p>
                  <p>
                    <font face="Times-Roman">resolutions dealt with the software crisis, and on the positive side, the software crisis led to the</font></p>
                  <p>
                    <font face="Times-Roman">deployment of Software Engineering paradigms.</font></p>
                  <p>
                    <font face="Times-BoldItalic" size="4"><i><b>Y2K Compliance</b></i></font></p>
                  <p>
                    <font face="Times-Roman">Just a few years ago, everyone can recall that we dealt with another chaos that put many</font></p>
                  <p>
                    <font face="Times-Roman">managers under tremendous stress and caused the firing of many. The worldwide problem</font></p>
                  <p>
                    <font face="Times-Roman">known as Y2K was both a programming problem and a managerial problem: We could not</font></p>
                  <p>
                    <font face="Times-Roman">The International Journal of Applied Management and Technology, Vol 3, Num 2</font></p>
                  <p>
                    <font face="Times-Roman">represent the year 2000 with 00 since 1900 was represented that way. What were we to do?</font></p>
                  <p>
                    <font face="Times-Roman">Should we write a new program to change all the data from two digits to four? Should we set a</font></p>
                  <p>
                    <font face="Times-Roman">flag for the new data? Yet another problem with Y2K is the year itself, 2000 which was a leap</font></p>
                  <p>
                    <font face="Times-Roman">year that was divisible by 400 (not every 4 years is a leap year, e.g. 1900). Y2K made</font></p>
                  <p>
                    <font face="Times-Roman">programmers with no managerial training run the show, thus taking over managerial duties.</font></p>
                  <p>
                    <font face="Times-Roman">Programmers instructed managers on what to do, often in a compressed period of time, which</font></p>
                  <p>
                    <font face="Times-Roman">seemed to challenge the authority and intelligence of managers.</font></p>
                  <p>
                    <font face="Times-Roman">Now is not the time to refresh our mind as to whose fault Y2K was, or why managers</font></p>
                  <p>
                    <font face="Times-Roman">waited so long to realize that a problem would occur. No one really knows exactly how much</font></p>
                  <p>
                    <font face="Times-Roman">time was spent to deal with this crisis, either directly or indirectly. In addition, the Y2K problem</font></p>
                  <p>
                    <font face="Times-Roman">and its aftermath was calculated to cost trillions of dollars. We are still paying for it. The trillion</font></p>
                  <p>
                    <font face="Times-Roman">plus dollars have been spent by businesses on Y2K compliance, liabilities, and lost productivity</font></p>
                  <p>
                    <font face="Times-Roman">due to computer crashes. Managers had to rethink and set survival strategies for the future. What will be the next</font></p>
                  <p>
                    <font face="Times-Roman">technology crisis? Should we wait for problems to occur and then tackle them? Why was the</font></p>
                  <p>
                    <font face="Times-Roman">Y2K issue not addressed at an earlier stage? Even if Y2K wasn’t preventable, involvement of</font></p>
                  <p>
                    <font face="Times-Roman">executives and managers with programmers at a far earlier stage would have reduced the overall</font></p>
                  <p>
                    <font face="Times-Roman">cost of Y2K. (Braithwaite, 2000).</font></p>
                  <p>
                    <font face="Times-BoldItalic" size="4"><i><b>Web Chaos, Spam, Spim, Spit</b></i></font></p>
                  <p>
                    <font face="Times-Roman">The web has become the platform for the e-market. Every business strives to become</font></p>
                  <p>
                    <font face="Times-Roman">web-oriented. What is going to happen if everyone is web-oriented and has a link to everyone</font></p>
                  <p>
                    <font face="Times-Roman">else? Let us examine the worst-case scenario where X e-businesses is connected to many other</font></p>
                  <p>
                    <font face="Times-Roman">M businesses and all the M businesses are connected to the X businesses (many-to-many</font></p>
                  <p>
                    <font face="Times-Roman">relationship). In addition, each of these businesses is linked to many nodes of their own. When</font></p>
                  <p>
                    <font face="Times-Roman">one system sends one request after another to other systems, there will be a point when too many</font></p>
                  <p>
                    <font face="Times-Roman">requests to a system cannot be handled. If we are not experiencing these difficulties yet, let us</font></p>
                  <p>
                    <font face="Times-Roman">simulate a possible scenario with web growth, a kind of fantasy of denial that one's system is</font></p>
                  <p>
                    <font face="Times-Roman">immune and that everything possible and necessary has been done to avoid problems. But</font></p>
                  <p>
                    <font face="Times-Roman">smooth internet use requires a sort of defensive driving where laws and regulations need to be</font></p>
                  <p>
                    <font face="Times-Roman">agreed and acted upon. For example making massive number of phone phone calls using the</font></p>
                  <p>
                    <font face="Times-Roman">internet instead of traditional phone lines can lead to chaos, which would hinder everyone. Less</font></p>
                  <p>
                    <font face="Times-Roman">than the potential for chaos, businesses, no less than individuals, need to look at the negative side</font></p>
                  <p>
                    <font face="Times-Roman">of e-marketing. Spam (unwanted mail, advertisement and messages) is organized and directed by</font></p>
                  <p>
                    <font face="Times-Roman">a program that generates enormous volumes of traffic and often hides its original source.</font></p>
                  <p>
                    <font face="Times-Roman">Similarly, unwanted instant messaging can be generated (SPIM) and Spit- Spam over Internet</font><font face="Times-Roman" size="2">.</font></p>
                  <p>
                    <font face="Times-Roman">Obviously, these Internet abuse (Spam, Spim and Spit) leads to waste of business time, waste of</font></p>
                  <p>
                    <font face="Times-Roman">space in memory, and more importantly, it aggravates the users and often creates emotional</font></p>
                  <p>
                    <font face="Times-Roman">distress in the workplace (Vinton, 2005).</font></p>
                  <p>
                    <font face="Times-BoldItalic" size="4"><i><b>V</b></i></font></p>
                  <p>
                    <font face="Times-BoldItalic" size="4"><i><b>irus Catastrophe, Phishing, and Trojan Horses</b></i></font></p>
                  <p>
                    <font face="Times-Roman">How would many managers react if an employee says, “MY MOUSE HAS A</font></p>
                  <p>
                    <font face="Times-Roman">VIRUS!”? Several probably would look at the person and politely ask, “Are you for real? A</font></p>
                  <p>
                    <font face="Times-Roman">mouse cannot get a virus.” Then s/he may look at the mouse on the desk, click it or roll it to see</font></p>
                  <p>
                    <font face="Times-Roman">if the ball is stuck. One common problem with the mouse in the good old days was the</font></p>
                  <p>
                    <font face="Times-Roman">malfunctioning of the driver program due to interference by some other programs. However,</font></p>
                  <p>
                    <font face="Times-Roman">how many managers are savvy enough to realize a virus could also corrupt a mouse drive. How</font></p>
                  <p>
                    <font face="Times-Roman">many know that a mouse becomes intelligent and sophisticated with its own programming? A</font></p>
                  <p>
                    <font face="Times-Roman">virus catastrophe requires a manager to understand what a virus is and how to handle it. A virus</font></p>
                  <p>
                    <font face="Times-Roman">is a program that can infect other programs or data stored in a file and it can knock down your IT</font></p>
                  <p>
                    <font face="Times-Roman">(Cohen, 1994). Just one virus “LOVE BUG” inflicted an estimated 10 billion dollars damage in</font></p>
                  <p>
                    <font face="Times-Roman">only a few days. Today, a malicious program can act as a real web site and collect information</font></p>
                  <p>
                    <font face="Times-Roman">such as passwords, and ordinary computer user cannot distinguish between the fake web site and</font></p>
                  <p>
                    <font face="Times-Roman">a real web site. Similarly, through Trojan horse, which has been placed in the user’s computer,</font></p>
                  <p>
                    <font face="Times-Roman">the passwords of other systems can be accessed. Managers should be able to observe the size of</font></p>
                  <p>
                    <font face="Times-Roman">programs and the data their companies have stored away for use. There is no doubt that a</font></p>
                  <p>
                    <font face="Times-Roman">manager’s knowledge of programming will lead to better decision-making that will prevent</font></p>
                  <p>
                    <font face="Times-Roman">errors. In case errors occur, managers will be able to understand the error, reports, recover lost</font></p>
                  <p>
                    <font face="Times-Roman">files and be able to communicate with programmers in order to resolve failure and defects, such</font></p>
                  <p>
                    <font face="Times-Roman">as viruses (Highland, 1997). A little understanding of programming can enable managers to take</font></p>
                  <p>
                    <font face="Times-Roman">proper protection measures for programs and data, such as writing to files for back up and</font></p>
                  <p>
                    <font face="Times-Roman">reading from files for recovery.</font></p>
                  <p>
                    <font face="TimesNewRomanPS-BoldMT" size="4"><b>The Benefit and Impact</b></font></p>
                  <p>
                    <font face="Times-Roman">Because a manager deals with people, quality, and planning, the decisions managers</font></p>
                  <p>
                    <font face="Times-Roman">make with regard to information technology can play a crucial role in the day-to-day affairs and</font></p>
                  <p>
                    <font face="Times-Roman">also have a consequential impact on the business. It is not enough for a manager to be an end</font></p>
                  <p>
                    <font face="Times-Roman">user or a computer operator. Managers also should actively participate in the information</font></p>
                  <p>
                    <font face="Times-Roman">technology ( IT) decision-making team with programmers and other technical personnel to</font></p>
                  <p>
                    <font face="Times-Roman">decide how IT is configured and customized to its organization's business needs. This requires</font></p>
                  <p>
                    <font face="Times-Roman">managers to have knowledge of programming foundations, and requiring programmers to have a</font></p>
                  <p>
                    <font face="Times-Roman">general idea of company operations, in order to efficiently for each application. With a little</font></p>
                  <p>
                    <font face="Times-Roman">routine update, from both a regularized task should become hassle-free. Nowadays, up-to-date</font></p>
                  <p>
                    <font face="Times-Roman">knowledge of computer technology can give a manager the skills to use the competitive</font></p>
                  <p>
                    <font face="Times-Roman">advantage gained by looking at other organizations' levels of information flow, marketing</font></p>
                  <p>
                    <font face="Times-Roman">strategies and more. Thus a well-prepared manager could see the code of other business websites</font></p>
                  <p>
                    <font face="Times-Roman">by right-clicking the mouse and selecting View Source. </font></p>
                  <p>
                    <font face="Times-Roman">With the increasing demand of the e-market, firms will need managers who understand</font></p>
                  <p>
                    <font face="Times-Roman">the technology, and are able to deal with the possibility of chaos and uncertainty without</font></p>
                  <p>
                    <font face="Times-Roman">interrupting business progress. Programming and its operating issues may determine the success</font></p>
                  <p>
                    <font face="Times-Roman">for some and root of failure for others. Managers will need skills to be able to avoid crisis, to</font></p>
                  <p>
                    <font face="Times-Roman">manage several kind of crisis, recognize a crisis, contain and resolve it, possibly even profit from</font></p>
                  <p>
                    <font face="Times-Roman">the crisis (Augustine, 1995). A manager who is able to handle a simple programming task can</font></p>
                  <p>
                    <font face="Times-Roman">better identify the real cause of problems rather than speculate about it. We conclude that</font></p>
                  <p>
                    <font face="Times-Roman">motivating managers to understand and to participate in programming issues will result in most,</font></p>
                  <p>
                    <font face="Times-Roman">if not all, of the following: higher quality of performance, better time management, reductions in</font></p>
                  <p>
                    <font face="Times-Roman">cost and risk, improved morale, greater respect from subordinate employees, and, finally,</font></p>
                  <p>
                    <font face="Times-Roman">becoming a marketable manager.</font></p>
                  <p>
                    <font face="Times-Bold" size="4"><b>References</b></font></p>
                  <p>
                    <font face="Times-Roman">Armour, P. (2004). When Executives Code, </font><font face="Times-Italic"><i>Communications of ACM</i></font><font face="Times-Roman">, </font><font face="Times-Italic"><i>47,1</i></font><font face="Times-Roman">, 19-22.</font></p>
                  <p>
                    <font face="Times-Roman">Augustine, N. (1995). Managing the crisis you tried to prevent, </font><font face="Times-Italic"><i>Harvard Business Review, </i></font><font face="Times-Roman">73,</font></p>
                  <p>
                    <font face="Times-Roman">147-159.</font></p>
                  <p>
                    <font face="Times-Roman">Benjamin, R. &amp; Blunt, J. (1992). Critical IT Issues: The next ten years, </font><font face="Times-Italic"><i>Sloan Management</i></font></p>
                  <p>
                    <font face="Times-Italic"><i>Review</i></font><font face="Times-Roman">; Summer, 33, 4.</font></p>
                  <p>
                    <font face="TimesNewRomanPSMT">Braithwaite, T. (2000). </font><font face="TimesNewRomanPS-ItalicMT"><i>Y2K Lessons Learned: A Guide to Better Information Technology</i></font></p>
                  <p>
                    <font face="TimesNewRomanPS-ItalicMT"><i>Management. </i></font><font face="TimesNewRomanPSMT">New York: John Wiley</font><font face="Times-Roman">.</font></p>
                  <p>
                    <font face="Times-Roman">Cerf, V (2005). Spam, Spim, and Spit, </font><font face="Times-Italic"><i>Communications of ACM</i></font><font face="Times-Roman">, 48, 4, 39-43</font></p>
                  <p>
                    <font face="Times-Roman">Cohen F. (1994). </font><font face="Times-Italic"><i>A Short Course on Computer Viruses</i></font><font face="Times-Roman">, New York: John Wiley.</font></p>
                  <p>
                    <font face="Times-Roman">Ebrahimi, A. (2003). </font><font face="Times-Italic"><i>C++ Programming Easy Ways (Volume I &amp; II)</i></font><font face="Times-Roman">. Boston: American Press.</font></p>
                  <p>
                    <font face="Times-Roman">Ebrahimi, A. (1992). VPCL: A Visual Language for Teaching and Learning Programming,</font></p>
                  <p>
                    <font face="Times-Italic"><i>Journal of Visual Languages and Computing, 3</i></font><font face="Times-Roman">, 299-317</font></p>
                  <p>
                    <font face="Times-Roman">Highland, H. (1997). Procedures To Reduce The Computer Virus Threat, </font><font face="Times-Italic"><i>Computers and</i></font></p>
                  <p>
                    <font face="Times-Italic"><i>Security</i></font><font face="Times-Roman">, 16,5, 439-449.</font></p>
                  <p>
                    <font face="Times-Roman">Sutcliffe, A. Mehandjiev, N. (2004). End-user development: Introduction, </font><font face="Times-Italic"><i>Communications of</i></font></p>
                  <p>
                    <font face="Times-Italic"><i>the ACM, </i></font><font face="Times-Roman">47,9, 31-32.</font></p>
                  <p>
                    <a href="http://http://www.drebrahimi.com/Data/Sites/1/module2-classnotes.pdf"><strong>Module 1 Class Notes<br />
                    </strong></a>These are class notes taken by a student I had a previous semester, that correspond with your assignment for this module. They are not necessary but some students find them helpful.&nbsp;</p>

                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingTwo">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Module Two
                </button>
              </h2>
            </div>
            <div id="collapseTwo" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Module Two</h5>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">
                    <a href="http://www.drebrahimi.com/Data/Sites/1/whatareinformationsystems%2Candwhyaretheyimportant.pdf" target='_blank' class="font-weight-bold">What are Information Systems, and why are they important?</a><br />
                    <small>From Chapter 2 of "Introduction to Information Systems"</small>
                  </li>
                  <li class="list-group-item">
                    <a href="http://www.drebrahimi.com/Data/Sites/1/ch0.ppt" target='_self' class="font-weight-bold">Chapter 1 from Introduction to Information Systems</a><br />
                    <small>PowerPoint overview of Chapter 1</small>
                  </li>
                  <li class="list-group-item">
                    <a href="http://www.drebrahimi.com/Data/Sites/1/ch02.ppt" target="_self" class="font-weight-bold">Chapter 2 from Introduction to Information Systems</a><br />
                    <small>PowerPoint overview of Chapter 2</small>
                  </li>
                  <li class="list-group-item">
                    <a href="http://www.drebrahimi.com/Data/Sites/1/module2-classnotes.pdf" target='_blank' class="font-weight-bold">Module 2 - Class Notes</a><br />
                    <small>These are class notes taken by a student I had a previous semester, that correspond with your assignment for this module. They are not necessary but some students find them helpful.</small>
                  </li>
                </ul>
                <div class="mt-4">
                  <h5><strong>Your Assignment: Write a one-page report</strong></h5>
                  <p>Summarize the Chapter 1 and 2 of the text and discuss on the discussion board.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingThree">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Module Three
                </button>
              </h2>
            </div>
            <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Module Three</h5>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item"> Discussion one<br />
                    <small>What are the key elements of Ethics, Privacy and Security in Information System and what are the problems</small>
                  </li>
                  <li class="list-group-item"> Discussion Two (optional) to boost your grade<br />
                    <small>How to build a good resume and publish it on the internet (make it a web page)</small>
                  </li>
                  <li class="list-group-item">
                    <a href="http://www.drebrahimi.com/Data/Sites/1/interestingreferences.pdf" target="_blank" class="font-weight-bold">Important links for reference</a>
                  </li>
                  <li class="list-group-item">
                    <a href="http://www.drebrahimi.com/Data/Sites/1/ch03.ppt" target='_blank' class="font-weight-bold">Chapter 3 from Introduction to Information Systems</a><br />
                    <small>Powerpoint Presentation</small>
                  </li>
                  <li class="list-group-item">
                    Assignment 3 - Ethics, Privacy and Security<br />
                  </li>
                  <li class="list-group-item">
                    <a href="http://www.drebrahimi.com/Data/Sites/1/whymanagersshouldbecomebetteracquaintedwithprogrammingissues%2C.pdf" target='_blank' class="font-weight-bold">Module 3 - Class Notes</a><br />
                    <small>These are class notes taken by a student I had a previous semester, that correspond with your assignment for this module. They are not necessary but some students find them helpful.</small>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingFour">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  Module Four
                </button>
              </h2>
            </div>
            <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Module Four</h5>
                <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                  <p>Data and Content Management</p>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <strong>Discuss the importance and understanding of knowledge management and how to create a Database</strong><br />
                      Design and create a simple Database (using Access or other DBMS)
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/quiz2.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>Quiz 2</strong>
                      </a><br />
                      Design and create a database consisting of at least three tables with relationships
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/midterm.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>Midterm</strong>
                      </a><br />
                      Write a research paper of 5 pages based on the material learned so far - as to why a manager needs to be acquainted with Information Systems
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/ch04.ppt" target="_blank" rel="noopener noreferrer">
                        <strong>Chapter 4 from Introduction to Information Systems</strong>
                      </a><br />
                      PowerPoint Presentation
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/midterm.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>Midterm Template</strong>
                      </a>
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/how_to_do_data_base_step_by_step.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>DATABASE HELP</strong>
                      </a>
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/quizhelp1.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>Quiz Help 1</strong>
                      </a><br />
                      <a href="http://www.drebrahimi.com/Data/Sites/1/quizhelp2.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>Quiz Help 2</strong>
                      </a>
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/info_for_managers_4th_module.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>Module 4 - Class Notes</strong>
                      </a><br />
                      These are class notes taken by a student I had in a previous semester, corresponding with your assignment for this module. They are not necessary but some students find them helpful.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingFive">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                  Module Five
                </button>
              </h2>
            </div>
            <div id="collapseFive" className="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Module Five</h5>
                <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                  <p>Network, Web, E-Business, Wireless, and Mobile Commerce</p>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <strong>Discuss the components of Network, Web, and E-Commerce</strong><br />
                      Chapter 5, 6, and 7
                    </li>
                    <li className="list-group-item">
                      <strong>Write a report on network, web, e-commerce, and mobility</strong><br />
                      Write a page report on why managers need to be acquainted with these topics. Discuss the challenges managers face in understanding network, web, and mobile computing, as well as the benefits and competitive advantages. Be sure to cite your references within the report and at the end.
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/ch05.ppt" target="_blank" rel="noopener noreferrer">
                        <strong>Chapter 5</strong>
                      </a><br />
                      PowerPoint Presentation
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/ch06.ppt" target="_blank" rel="noopener noreferrer">
                        <strong>Chapter 6</strong>
                      </a><br />
                      PowerPoint Presentation
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/chapter_7.ppt" target="_blank" rel="noopener noreferrer">
                        <strong>Chapter 7</strong>
                      </a><br />
                      PowerPoint Presentation
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/sample_paper_amp110209.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>Sample FINAL Paper</strong>
                      </a>
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/info_for_managers_5th_module.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>Module 5 – Class Notes</strong>
                      </a><br />
                      These are class notes taken by a student from a previous semester that correspond with your assignment for this module. They are not necessary but may be helpful.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingSix">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                  Module Six
                </button>
              </h2>
            </div>
            <div id="collapseSix" className="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Module Six</h5>
                <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                  <p>
                    Organizational Information Systems<br />
                    Manager's Research and Development,<br />
                    Discussion, Assignment, and Quiz
                  </p>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/gradingcriteriaformodule6assignment.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>Grading Criteria for Module 6 Assignment.doc</strong>
                      </a>
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/ch08.ppt" target="_blank" rel="noopener noreferrer">
                        <strong>Chapter 8 from Introduction to Information Systems</strong>
                      </a><br />
                      PowerPoint Presentation
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/supplementalnotes-module6.ppt" target="_blank" rel="noopener noreferrer">
                        <strong>Supplement to November 4, 2008 Notes</strong>
                      </a>
                    </li>
                    <li className="list-group-item">
                      <strong>Manager's Research and Development: How to publish your project, what are the criteria, and how to go about it</strong><br />
                      Discuss ways that you can publish your work in academic or managerial journals.
                    </li>
                    <li className="list-group-item">
                      <strong>Write a page report analyzing 10 to 20 manager resumes</strong>
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/" target="_blank" rel="noopener noreferrer">
                        <strong>Quiz 3: Build a payroll worksheet (Hourly based salary) for a company using Excel</strong>
                      </a><br />
                      Exercise with Microsoft Excel or any other spreadsheets
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/globalisadelphi111108.ppt" target="_blank" rel="noopener noreferrer">
                        <strong>PowerPoint Presentation prepared by Dr. Ebrahimi</strong>
                      </a>
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/samplepayroll.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>Sample Payroll Excel Sheet</strong>
                      </a><br />
                      Courtesy of: Maggie Gajda
                    </li>
                    <li className="list-group-item">
                      <strong>Module 6 - Class Notes</strong><br />
                      These are class notes taken by a student from a previous semester that correspond with your assignment for this module. They are not necessary but may be helpful.<br />
                      <a href="http://www.drebrahimi.com/Data/Sites/1/module6classnotes1of5.pdf" target="_blank" rel="noopener noreferrer"><strong>Part 1 of 4</strong></a><br />
                      <a href="http://www.drebrahimi.com/Data/Sites/1/module6classnotes2of5.pdf" target="_blank" rel="noopener noreferrer"><strong>Part 2 of 4</strong></a><br />
                      <a href="http://www.drebrahimi.com/Data/Sites/1/module6classnotes3of5.pdf" target="_blank" rel="noopener noreferrer"><strong>Part 3 of 4</strong></a><br />
                      <a href="http://www.drebrahimi.com/Data/Sites/1/module6classnotes4of5.pdf" target="_blank" rel="noopener noreferrer"><strong>Part 4 of 4</strong></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingSeven">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                  Module Seven
                </button>
              </h2>
            </div>
            <div id="collapseSeven" className="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Module Seven</h5>
                <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                  <p>
                    Managerial Support Systems &amp; Acquiring IT Applications<br />
                    Ch. 9 Managerial Support Systems - Ch. 10 Acquiring Info Systems &amp; Applications
                  </p>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/quiz_answers.docx" target="_blank" rel="noopener noreferrer">
                        <strong>Quiz Answers</strong>
                      </a>
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/program_presentation.ppt" target="_blank" rel="noopener noreferrer">
                        <strong>Program Presentation</strong>
                      </a>
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/ch09.ppt" target="_blank" rel="noopener noreferrer">
                        <strong>Chapter 9 from Introduction to Information Systems</strong>
                      </a><br />
                      PowerPoint Presentation
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/katierose_resume_03.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>Sample In-class Submission - Study several managerial resumes and rank them based on what you have learned</strong>
                      </a><br />
                      Credit: Katierose Brower
                    </li>
                    <li className="list-group-item">
                      <strong>Discuss the importance of managerial support systems and how to acquire them</strong>
                    </li>
                    <li className="list-group-item">
                      <strong>Write a page report on the importance of managerial support systems and how managers should acquire IT applications</strong>
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/ch10.ppt" target="_blank" rel="noopener noreferrer">
                        <strong>Chapter 10 from Introduction to Information Systems</strong>
                      </a><br />
                      PowerPoint Presentation
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/eamsubmission.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>EAM 2009 Submission Guidelines</strong>
                      </a><br />
                      Submit YOUR report by December 8th
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/info_for_managers_7th_module.doc" target="_blank" rel="noopener noreferrer">
                        <strong>Module 7 - Class Notes</strong>
                      </a><br />
                      These are class notes taken by a student from a previous semester that correspond with your assignment for this module. They are not necessary but may be helpful.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingFinal">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFinal" aria-expanded="false" aria-controls="collapseFinal">
                  Module Final
                </button>
              </h2>
            </div>
            <div id="collapseFinal" className="collapse" aria-labelledby="headingFinal" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Module Final</h5>
                <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                  <p>
                    Final research project (expansion of midterm) and Quiz 4
                  </p>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/finalmoduleclassnotes.doc" target="_blank" rel="noopener noreferrer">
                        <strong>Class Notes from December 9th, 2008</strong>
                      </a>
                    </li>
                    <li className="list-group-item">
                      <strong>Sample C++ Program</strong><br />
                      Must be opened with a C++ compiler
                    </li>
                    <li className="list-group-item">
                      <strong>Final paper submission</strong><br />
                      Submit your 10-page paper with references here. Last submission is Dec. 15.
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/programmingandsoftwaredevelopmentissues.pdf" target="_blank" rel="noopener noreferrer">
                        <strong>Quiz #4: Programming and Software Development Issues</strong>
                      </a><br />
                      Answer 10 questions from a 20-question pool by writing a program.
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/howtoexecuteitthrucommandpromt.docx" target="_blank" rel="noopener noreferrer">
                        <strong>HOW TO EXECUTE IT THROUGH COMMAND PROMPT</strong>
                      </a>
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/finalquestions-helpingyoutodotheprogramwriting.docx" target="_blank" rel="noopener noreferrer">
                        <strong>FINAL QUIZ QUESTIONS</strong>
                      </a>
                    </li>
                    <li className="list-group-item">
                      <a href="http://www.drebrahimi.com/Data/Sites/1/info_for_managers_final_module.doc" target="_blank" rel="noopener noreferrer">
                        <strong>Final Module - Class Notes</strong>
                      </a><br />
                      These are class notes taken by a student from a previous semester that correspond with your assignment for this module. They are not necessary but may be helpful.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingSuppliementry">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseSuppliementry" aria-expanded="false" aria-controls="collapseSuppliementry">
                  Supplemental Materials
                </button>
              </h2>
            </div>
            <div id="collapseSuppliementry" className="collapse" aria-labelledby="headingSuppliementry" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Supplemental Materials</h5>
                <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                  <h4>Link to Dr. Ebrahimi's research:</h4>
                  <h3 style={{ textAlign: 'center' }}>
                    <a href="https://www.scribd.com/document/409684355/Ubiquitous-Learning-Vol-11-Iss-1-Improving-Management-Education-Outcomes" target="_blank" rel="noopener noreferrer">
                      Improving Management Education Outcomes
                    </a>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-3">
          <iframe frameBorder="0" height="300" title="myFrame"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3020.3113589675813!2d-73.57774648414325!3d40.79915127932243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c286b96a1b2727%3A0xad943160e075b92f!2sNew+Academic+Building+at+SUNY+Old+Westbury!5e0!3m2!1sen!2sus!4v1513701666413"
            className="iframeStyle">
          </iframe>
        </div>
      </div>
    </>
  );
}

export default Infosys;